export enum SubscriptionType {
  Monthly = 'monthly',
  Annual = 'annual',
}

export interface PaymentAgentParams {
  userId: string;
  url: URL;
  onReady?: (state: PaymentAgentReadyState) => void;
  onError?: (error: Error) => void;
  onPaymentApproved?: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;
  onPaymentVerified?: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;
  onPaymentFinalized?: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;
  onInitError?: (errors: ProviderError[]) => void;
  onPaymentCancelled?: (message: string) => void;
}

export interface PaymentAgentReadyState {
  pricesBySubscriptionType: Record<SubscriptionType, string>;
}

export interface ProviderError {
  message: string;
  code: ProviderErrorCode;
}

export enum ProviderErrorCode {
  UNKNOWN,
  IN_APP_PURCHASES_DISABLED,
}

export interface PaymentProvider {
  getId: () => string;
  createAgent(params: PaymentAgentParams): Promise<PaymentAgent>;
}

export interface PaymentAgent {
  /**
   * Orders a subscription for the user
   * @returns Created order metadata, could be different between platforms
   */
  order(subscriptionType: SubscriptionType, userId: string): Promise<void>;

  /**
   * Force approve a payment
   */
  approvePayment: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;

  /**
   * Force verify a payment
   */
  verifyPayment: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;

  /**
   * Force finalize a payment
   */
  finalizePayment: (
    subscriptionType: SubscriptionType,
    metadata?: Record<string, any>,
  ) => void;

  /**
   * Raise an error
   */
  raiseError: (error: Error) => void;
}
